import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { selectSx } from './filterStyles';

const toggleSx = {
  '& .MuiToggleButton-root': { textTransform: 'none', fontSize: '0.8rem', py: 0.25, px: 1.5 },
};

/**
 * Filtro de várias opções com modo "Mostrar só" (inclusão) ou "Esconder" (exclusão).
 * @param {{ label: string, value: { values: string[], exclude: boolean },
 *   options: Array<{ value: string, label: string }>, onChange: Function }} props
 */
function MultiFilterSelect({ label, value, options, onChange }) {
  const labelOf = (v) => options.find((opt) => opt.value === v)?.label || v;

  const renderValue = (selected) => {
    if (!selected.length) return `${label}: todos`;
    return `${label}: ${value.exclude ? 'sem ' : ''}${selected.map(labelOf).join(', ')}`;
  };

  return (
    <Select
      multiple
      size="small"
      displayEmpty
      value={value.values}
      onChange={(e) => onChange({ ...value, values: e.target.value.filter(Boolean) })}
      renderValue={renderValue}
      sx={{ ...selectSx, maxWidth: 280 }}
    >
      <ListSubheader sx={{ lineHeight: 1, py: 1 }}>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={value.exclude ? 'exclude' : 'include'}
          onChange={(_, mode) => mode && onChange({ ...value, exclude: mode === 'exclude' })}
          sx={toggleSx}
        >
          <ToggleButton value="include">Mostrar só</ToggleButton>
          <ToggleButton value="exclude">Esconder</ToggleButton>
        </ToggleButtonGroup>
      </ListSubheader>
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value} dense>
          <Checkbox size="small" checked={value.values.includes(opt.value)} sx={{ p: 0.5, mr: 1 }} />
          <ListItemText primary={opt.label} primaryTypographyProps={{ fontSize: '0.875rem' }} />
        </MenuItem>
      ))}
    </Select>
  );
}

export default MultiFilterSelect;
